import type { ConcedeAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { KineticCoreState } from "../types/game-state";

/**
 * Concede is allowed for either participant at any point while the match
 * is RUNNING, regardless of whose turn it currently is. Players give up
 * the game whenever they choose — gating concede behind the active turn
 * makes the resign button silently no-op for the waiting player, which
 * is a UX trap (and breaks the multiplayer client's game-over flow when
 * the non-active player resigns).
 */
export function validateConcede(
  state: KineticCoreState,
  action: ConcedeAction,
): ValidationResult {
  if (state.phase !== "RUNNING") {
    return { valid: false, error: "Match is not running" };
  }

  const isKnownParticipant = state.participants.some(
    (participant) => participant.id === action.participantId,
  );
  if (!isKnownParticipant) {
    return { valid: false, error: "Unknown participant" };
  }

  return { valid: true };
}
